import type { ReactNode } from "react";
import { ToastType } from "../toasts/core/types";
import { AlertCircle, CheckCircle } from "@untitled-ui/icons-react";

const RadialIcon = ({
  colorClassName,
  children,
}: {
  colorClassName: string;
  children: ReactNode;
}) => {
  return (
    <div className="relative flex">
      {children}
      <span
        className={
          "absolute -top-[0.21rem] -left-[0.21rem] h-[1.67rem] w-[1.67rem] rounded-full border-[1.67px] opacity-30 " +
          colorClassName
        }
      />
      <span
        className={
          "absolute -top-[0.47rem] -left-[0.47rem] h-[2.19rem] w-[2.19rem] rounded-full border-[1.67px] opacity-10 " +
          colorClassName
        }
      />
    </div>
  );
};

export const iconByNotificationType: { [S in ToastType]: ReactNode } = {
  success: (
    <RadialIcon colorClassName="border-success-v2-600">
      <CheckCircle className="h-5 w-5 min-w-5 text-success-v2-600" />
    </RadialIcon>
  ),
  error: (
    <RadialIcon colorClassName="border-error-v2-600">
      <AlertCircle className="h-5 w-5 min-w-5 text-error-v2-600" />
    </RadialIcon>
  ),
  warning: (
    <RadialIcon colorClassName="border-success-v2-600">
      <CheckCircle className="h-5 w-5 min-w-5 text-success-v2-600" />
    </RadialIcon>
  ),
  info: (
    <RadialIcon colorClassName="border-success-v2-600">
      <CheckCircle className="h-5 w-5 min-w-5 text-success-v2-600" />
    </RadialIcon>
  ),
  peach: (
    <RadialIcon colorClassName="border-success-v2-600">
      <CheckCircle className="h-5 w-5 min-w-5 text-success-v2-600" />
    </RadialIcon>
  ),
};
